import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OnboardIndividualRequest } from '@app/finxone-web-frontend/app/lib/services/metadata-service/metadata-service.type';
import {
  OnboardIndividualSingupFinishedFormStructure,
} from '@app/finxone-web-frontend/app/lib/utils/onboarding/form.types';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { AlertHandlerService } from '@finxone-platform/shared/services';
import {
  BaseCssProperties,
  KycLevel,
  LayoutWidgetConfig,
  ProviderClass,
  TextItemWidgetConfig,
  WidgetLayout,
  WidgetNames,
} from '@finxone-platform/shared/sys-config-types';
import { Subject, debounceTime, map, takeUntil } from 'rxjs';
import { ConfigService } from '../../../../lib/services/config-service/config-service.service';
import { MetadataService } from '../../../../lib/services/metadata-service/metadata-service.service';
import {
  FormStage,
  MultiPartFormHolderService,
} from '../../../../lib/services/multipart-holder/multipart-form-holder.service';
import { BaseComponent } from '../base/base.component';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-button-widget',
  templateUrl: './button-widget.component.html',
  styleUrls: ['./button-widget.component.scss'],
})
export class ButtonWidgetComponent extends BaseComponent implements OnInit {
  public widgetLayout: WidgetLayout;
  public parentComponent = 'menu';
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  widgetsAttributes: LayoutWidgetConfig[] = [];
  currentWidgetPosition: number;
  title: string;
  url: string | undefined;
  btnFnName: any;
  userProfileData: any;
  proceedButtonDisabled = true;

  constructor(
    private configService: ConfigService,
    private metadataService: MetadataService,
    private formHolderService: MultiPartFormHolderService,
    public dataIn: ProviderClass<TextItemWidgetConfig>,
    private _router: Router,
    private alertHandlerService: AlertHandlerService,
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.dataIn != undefined && this.dataIn != null) {
      this.attri = this.dataIn.attri;
      this.title = this.dataIn.attri?.widgetProperties?.textContent ?? this.dataIn.attri.title;
      this.url = this.dataIn.attri.url;

      this.btnFnName = this.dataIn.attri?.btnFnName ? this.dataIn.attri?.btnFnName : 'verify';
      this.userProfileData = this.dataIn.userProfileData;
    }

    this.contentStyle = this.configService.getSpecificBaseCssStyle(this.attri, [
      BaseCssProperties.MARGIN,
      BaseCssProperties.PADDING,
      BaseCssProperties.COLOR,
      BaseCssProperties.TEXTALIGN,
      BaseCssProperties.BACKGROUND_COLOR,
      BaseCssProperties.BORDER,
      BaseCssProperties.V_ALIGN,
      BaseCssProperties.DISABLE_BACKGROUND_COLOR,
      BaseCssProperties.DISABLE_COLOR,
    ]);

    if (!this.configService.getActiveConfigType().isWorkflow)
      this.formHolderService.config.allFormsValid$.subscribe((res) => {
        this.proceedButtonStatus();
      });
  }

  proceedButtonStatus() {
    this.proceedButtonDisabled = false;
    // eslint-disable-next-line no-unsafe-optional-chaining
    if (this.formHolderService?.config?.['stages']) {
      for (const stageForm of this.formHolderService.config['stages']) {
        if (!stageForm.getForm()?.valid) {
          this.proceedButtonDisabled = true;
        }
        const form = this.formHolderService.config.concatSignupFormsToJson();
        if (!form.phone_widget.isPhoneVerified || !form.email_widget.isEmailVerified) {
          this.proceedButtonDisabled = true;
        }
        this.checkBtnStatus();
      }
    }

    if (this.dataIn?.allwidgets) {
      this.dataIn?.allwidgets.forEach((widgetName: any) => {
        if (
          [
            WidgetNames.NAME_WIDGET,
            WidgetNames.EMAIL_WIDGET,
            WidgetNames.PHONE_WIDGET,
            WidgetNames.ADDRESS_WIDGET,
            WidgetNames.BIRTHDAY_WIDGET,
          ].includes(widgetName.name as WidgetNames)
        ) {
          const stageForm = this.formHolderService.config.getStage(widgetName.name);
          if (stageForm.getForm().valid === false) {
            this.proceedButtonDisabled = true;
          }
          this.checkVerifyBtnStatus(widgetName, stageForm);
        }
      });
    }
  }

  checkBtnStatus() {
    this.contentStyle = this.configService.getSpecificBaseCssStyle(this.attri, [
      BaseCssProperties.MARGIN,
      BaseCssProperties.PADDING,
      this.proceedButtonDisabled ? BaseCssProperties.DISABLE_COLOR : BaseCssProperties.COLOR,
      BaseCssProperties.TEXTALIGN,
      this.proceedButtonDisabled
        ? BaseCssProperties.DISABLE_BACKGROUND_COLOR
        : BaseCssProperties.BACKGROUND_COLOR,
      BaseCssProperties.BORDER,
      BaseCssProperties.V_ALIGN,
    ]);
  }

  checkVerifyBtnStatus(widgetName: LayoutWidgetConfig, stageForm: FormStage) {
    if (widgetName.name == WidgetNames.EMAIL_WIDGET && !stageForm.getForm().value?.isEmailVerified) {
      this.proceedButtonDisabled = true;
    }
    if (widgetName.name == WidgetNames.PHONE_WIDGET && !stageForm.getForm().value?.isPhoneVerified) {
      this.proceedButtonDisabled = true;
    }
    this.checkBtnStatus();
  }

  verify() {
    alert('verify');
  }

  kyc() {
    const form = this.formHolderService.config.concatSignupFormsToJson();
    if (!form.email_widget.isEmailVerified && !form.phone_widget.isPhoneVerified) {
      this.showMsg('error', 'Email and Phone are not yet verified.');
    } else if (!form.email_widget.isEmailVerified) {
      this.showMsg('error', 'Email is not yet verified.');
    } else if (!form.phone_widget.isPhoneVerified) {
      this.showMsg('error', 'Phone is not yet verified.');
    } else {
      this.metadataService
        .updateUser(this.transformFormControlsToOnboardSignupCall(form), true)
        .pipe(
          debounceTime(300),
          takeUntil(this.destroy$),
          map(() => {
            this.showMsg(
              'success',
              'The Know Your Customer validation submission has completed successfully.',
            );
            this._router.navigateByUrl('/zones/verification/verify?type=' + KycLevel.PERSONAL);
          }),
        )
        .subscribe();
    }
  }

  private transformFormControlsToOnboardSignupCall(
    form: OnboardIndividualSingupFinishedFormStructure,
  ): OnboardIndividualRequest {
    const request = {
      firstName: form.name_widget.first_name,
      middleName: form.name_widget.middle_name,
      lastName: form.name_widget.last_name,
      dob: this.setDateFormat(form.birthday_widget.date_of_birth).toString(),
      email: form.email_widget.email,
      phoneNumber: form.phone_widget.country_code + form.phone_widget.phone,
      country:
        typeof form.address_widget.country == 'string'
          ? form.address_widget.country
          : form.address_widget.country?.['code'],
      address1: form.address_widget.line_1,
      address2: form.address_widget.line_2,
      address3: form.address_widget.line_3,
      address4: form.address_widget.line_4,
      city: form.address_widget.city,
      county: form.address_widget.county,
      postalCode: form.address_widget.post_code,
      roleId: this.dataIn.userProfile.roleId,
      id: this.dataIn.userProfile.id,
      userName: form.email_widget.email,
      phoneVerified: form.phone_widget.isPhoneVerified as unknown as string,
    };
    return request;
  }

  setDateFormat(date: Date) {
    date = new Date(date);
    const fullYear = date.getFullYear();
    const fullMonth = (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1);
    const fullDate = (date.getDate() < 10 ? '0' : '') + date.getDate();

    return fullYear + '-' + fullMonth + '-' + fullDate;
  }
  callFunctionByName() {
    const fnction: keyof ButtonWidgetComponent = this.btnFnName;
    if (this[fnction]) {
      this[fnction]();
    } else {
      alert('Function with ' + this.btnFnName + ' name not created!');
    }
  }

  showMsg(type: 'success' | 'error', msg: string) {
    this.alertHandlerService.showAlertFn(type, msg);
  }
}
